import React from "react";
import css from "./VirtualCheckInDayRow.scss";
import WeeklyDropdown from "common/WeeklyDropdown";
import PropTypes from "prop-types";
import VirtualCheckInTimeSlot from "./VirtualCheckInTimeSlot";
import Icon from "SF/MaterialIcon";
import classnames from 'classnames';
import {SFVirtualCheckInDaySchedule, SFVirtualCheckInModifySchedule} from "utils/types";

const VirtualCheckInDayRow = (props) => {
    return (
        <div className={css['days-and-times']} data-testid = {"day-schedule-" + props.rowIdx}>
            <div className={classnames(css['virtual-schedule-day'], {[css.error]: !!props.daySchedule.error })}>
                <label className={css['label-text']}><span>Open Day</span>
                <WeeklyDropdown id={"day-" + props.rowIdx}
                                ariaLabel="Select day of week for schedule"
                                className={classnames(css["dayOfWeekDropdown"])}
                                placeholder="Select Day of Week"
                                options={props.availableDaysOfWeek}
                                onChange={(value) => props.modifyCheckInSchedule.timeSlotCallBacks.setDayOfWeek(props.rowIdx, value)}
                                value={props.daySchedule.dayOfWeek} />
                </label>
                {props.daySchedule.error && <div className={css['error-message']}><Icon icon="error" aria-hidden="true" />{props.daySchedule.error}</div>}
            </div>
            <table className={css['table']}>
                <tbody>
                    {props.daySchedule.timeSlots.map((slot, idx) =>
                            <VirtualCheckInTimeSlot rowId={props.rowIdx}
                                                    slot={slot}
                                                    key={idx}
                                                    idx={idx}
                                                    abbreviatedTZ={props.abbreviatedTZ}
                                                    modifyCheckInSchedule={props.modifyCheckInSchedule} />
                        )
                    }
                </tbody>
            </table>
        </div>
    );
}

VirtualCheckInDayRow.propTypes = {
    availableDaysOfWeek: WeeklyDropdown.daysOfTheWeekType.isRequired,
    daySchedule: SFVirtualCheckInDaySchedule.isRequired,
    rowIdx: PropTypes.number.isRequired,
    modifyCheckInSchedule: SFVirtualCheckInModifySchedule.isRequired,
    ...VirtualCheckInTimeSlot.props
}

export default VirtualCheckInDayRow;
